import { Datepicker } from 'vanillajs-datepicker';

Datepicker.locales.cs = {
  days: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
  daysShort: ["Ned", "Pon", "Úte", "Stř", "Čtv", "Pát", "Sob"],
  daysMin: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
  months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
  monthsShort: ["Led", "Úno", "Bře", "Dub", "Kvě", "Čer", "Čnc", "Srp", "Zář", "Říj", "Lis", "Pro"],
  today: "Dnes",
  clear: "Vymazat",
  monthsTitle: "Měsíc",
  weekStart: 1,
  format: "dd.mm.yyyy"
}

Datepicker.locales.de = {
  days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  daysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  today: "Heute",
  monthsTitle: "Monate",
  clear: "Löschen",
  weekStart: 1,
  format: "dd.mm.yyyy"
}

Datepicker.locales.ru = {
  days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
  daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб"],
  daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
  monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
  today: "Сегодня",
  clear: "Очистить",
  format: "dd.mm.yyyy",
  weekStart: 1,
  monthsTitle: 'Месяцы'
}

Datepicker.locales.sk = {
  days: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
  daysShort: ["Ned", "Pon", "Uto", "Str", "Štv", "Pia", "Sob"],
  daysMin: ["Ne", "Po", "Ut", "St", "Št", "Pia", "So"],
  months: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "Máj", "Jún", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
  today: "Dnes",
  clear: "Vymazať",
  weekStart: 1,
  format: "d.m.yyyy"
}

const elem = document.querySelector('.js-FieldDate');

if(elem){
  const locale = elem.getAttribute('data-locale')

  new Datepicker(elem, {
    todayHighlight: true,
    pickLevel: 0,
    language: locale,
    autohide: true,
    minDate: Date.now()
  })
}
